export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: "menuitems.dashboard.text",
        link: "/",
        icon: "bx-home-circle",
    },

    {
        id: 3,
        label: "menuitems.test.text",
        link: "/test",
        icon: "bx-test-tube",
    },

    {
        id: 4,
        label: "menuitems.bookings.text",
        link: "/bookings",
        icon: "bx-analyse",
    },

    {
        id: 5,
        label: "menuitems.schedule.text",
        link: "/schedule",
        icon: "bxs-alarm",
    },

    {
        id: 7,
        label: "menuitems.counters.text",
        link: "/counters",
        icon: "bxs-user-voice",
    },

    {
        id: 8,
        label: "menuitems.outsourceTokenCalls.text",
        link: "/outsource-token-calls",
        icon: "bx-phone-call",
    },

    {
        id: 6,
        label: "menuitems.profile.text",
        link: "/profile",
        icon: "bxs-user-rectangle",
    },

    // {
    //     id: 8,
    //     label: "menuitems.consultations.text",
    //     link: "/consultations",
    //     icon: "bxs-calendar-event",
    // },

    // {
    //     id: 14,
    //     label: "menuitems.pharmacy.text",
    //     link: "",
    //     icon: "bxs-capsule",

    //     subItems: [
    //         {
    //             id: 15,
    //             label: "menuitems.pharmacy.list.orders",
    //             link: "/pharmacy-orders",
    //             parentId: 14
    //         },
    //         {
    //             id: 16,
    //             label: "menuitems.pharmacy.list.requests",
    //             link: "/pharmacy-requests",
    //             parentId: 14
    //         },
    //     ]
    // },
    

    // {
    //     id: 9,
    //     label: "menuitems.doctors.text",
    //     link: "",
    //     icon: "bx-plus-medical",
        
    //     subItems: [
    //         {
    //             id: 10,
    //             label: "menuitems.doctors.list.pending",
    //             link: "/doctors/pending",
    //             parentId: 9
    //         },
    //         {
    //             id: 11,
    //             label: "menuitems.doctors.list.approved",
    //             link: "/doctors",
    //             parentId: 9
    //         },
    //         {
    //             id: 12,
    //             label: "menuitems.doctors.list.payments",
    //             link: "/doctors/payments",
    //             parentId: 9
    //         },
    //     ]
    // },

    // {
    //     id: 18,
    //     label: "menuitems.coupons.text",
    //     link: "/coupons",
    //     icon: "bxs-coupon",
    // },


    // {
    //     id: 13,
    //     label: "menuitems.specializations.text",
    //     link: "/specializations",
    //     icon: "bx-book",
    // },    

    // {
    //     id: 17,
    //     label: "menuitems.sliders.text",
    //     link: "/sliders",
    //     icon: "bx-slider-alt",
    // },    

    // {
    //     id: 19,
    //     label: "menuitems.languages.text",
    //     link: "/languages",
    //     icon: "bx-user-voice",
    // },

    // {
    //     id: 20,
    //     label: "menuitems.deliverystaffs.text",
    //     link: "/delivery-staffs",
    //     icon: "bxs-cart",
    // }, 

    // {
    //     id: 21,
    //     label: "menuitems.marketingstaffs.text",
    //     link: "/marketing-staffs",
    //     icon: "bx-briefcase",
    // }, 

    // {
    //     id: 22,
    //     label: "menuitems.clinics.text",
    //     link: "/clinics",
    //     icon: "bx-clinic",
    // },

    // {
    //     id: 23,
    //     label: "menuitems.tvshows.text",
    //     link: "/tvshows",
    //     icon: "bx-tv",
    // },

    // {
    //     id: 24,
    //     label: "menuitems.scrollcontents.text",
    //     link: "/scroll-contents",
    //     icon: "bx-book-content",
    // },

    // {
    //     id: 25,
    //     label: "menuitems.feedbacks.text",
    //     link: "/feedbacks",
    //     icon: "bx-message-dots",
    // },

    // {
    //     id: 26,
    //     label: "menuitems.faqs.text",
    //     link: "/faqs",
    //     icon: "bx-question-mark",
    // },

    // {
    //     id: 27,
    //     label: "menuitems.notifications.text",
    //     link: "/notifications",
    //     icon: "bx-bell",
    // },

    // {
    //     id: 28,
    //     label: "menuitems.settings.text",
    //     link: "/settings",
    //     icon: "bx-cog",
    // },
];

